import { useCallback, useMemo } from 'react';

import { useDefaultEvents, useGrid } from '@Components/Grid';

export default function useEvents() {
  const { store: { collection: { fetchById, save } }, handleRefresh } = useGrid()
  const { handleDeleteEntry, handleUpdateEntry } = useDefaultEvents()

  const handleDuplicateEntry = useCallback(async row => {
    const { id, name } = row
    const data = await fetchById(id)
    data.id = null
    data.name = name

    if (data.integrationDataParsed?.optimize) {
      data.slots = data.slots.map(slot => {
        delete slot.id
        delete slot.pathId
        return slot
      });
    }

    await save(data)
    await handleRefresh()
  }, [fetchById, save, handleRefresh])

  return useMemo(() => ({
    handleUpdateEntry,
    handleDeleteEntry,
    handleDuplicateEntry,
  }), [handleUpdateEntry, handleDeleteEntry, handleDuplicateEntry])
}
